document.addEventListener("DOMContentLoaded", function () {
    // Function to initialize all the cards
    function initializeCards() {
        document.querySelectorAll(".card-reviews .excerpt-holder").forEach(holder => {
            // Get the text content of the holder
            let textContent = holder.textContent.trim();
            // Split the content into words
            let words = textContent.split(/\s+/);

            if (words.length > 15) {  // If word count exceeds 15
                // Limit the content to the first 15 words and add ellipsis
                let truncatedContent = words.slice(0, 15).join(" ") + " ";
                holder.textContent = truncatedContent;  // Set the shortened text

                // Create a container for extra content
                let extraContent = document.createElement("span");
                extraContent.classList.add("extra-content");
                extraContent.textContent = words.slice(15).join(" "); // The remaining content
                extraContent.style.display = "none";  // Hide the extra content initially

                // Add the extra content after the truncated content
                holder.appendChild(extraContent);

                // Add ellipsis element for toggling
                let ellipsis = document.createElement("span");
                ellipsis.classList.add("ellipsis");
                ellipsis.textContent = "...";
                holder.appendChild(ellipsis);

                let buttonHolder = document.createElement("div");  // Create button holder
                buttonHolder.classList.add("buttons-holder");

                let button = document.createElement("button");
                button.textContent = theme_object.messages.read_more;
                button.classList.add("read-more-btn");
                button.classList.add("btn-small");

                buttonHolder.appendChild(button);  // Add button to buttonHolder
                holder.after(buttonHolder);  // Add buttonHolder to the DOM
            }
        });
    }

    // Initialize cards on page load
    initializeCards();

    // Event delegation for dynamically loaded content and default content
    document.addEventListener("click", function (e) {
        // Check if the clicked element is a button with the class "read-more-btn"
        if (e.target && e.target.classList.contains("read-more-btn")) {
            let clickedButton = e.target;
            let buttonHolder = clickedButton.closest(".buttons-holder");
            
            // Find the excerpt holder by going up the DOM from buttonHolder
            let parentHolder = buttonHolder ? buttonHolder.previousElementSibling : null;

            if (parentHolder && parentHolder.classList.contains("excerpt-holder")) {
                let extraContent = parentHolder.querySelector(".extra-content");
                let ellipsis = parentHolder.querySelector(".ellipsis");

                // Toggle the expanded class and change the button text
                parentHolder.classList.toggle("expanded");
                clickedButton.textContent = parentHolder.classList.contains("expanded") ? theme_object.messages.read_less : theme_object.messages.read_more;

                // Toggle full or truncated content visibility without modifying the original content
                if (parentHolder.classList.contains("expanded")) {
                    extraContent.style.display = "inline";  // Show extra content
                    ellipsis.style.display = "none";  // Hide ellipsis
                } else {
                    extraContent.style.display = "none";  // Hide extra content
                    ellipsis.style.display = "inline";  // Show ellipsis
                }
            }
        }
    });
});
